import {useSettingsQuery} from '../../../common/providers/ApiInterface'

export const useAreaDetails = (areaUpmId?: string) => {
  return useSettingsQuery('upmAreaDetails', [areaUpmId], {
    enabled: !!areaUpmId,
    gcTime: 0,
    retry: false,
    staleTime: 0
  })
}

export const QueryKey = 'areaDetails'
